function initCardListSwiperWrapper() {
  const containers = document.querySelectorAll('.tw-carousel-list-swiper');
  if (!containers || containers.length === 0) return;

  let swipers = [];

  const destroySwipers = () => {
    swipers.forEach((swiper) => swiper.destroy(true, true));
    swipers = [];
  };

  const initSwipers = (isXl) => {
    destroySwipers();

    containers.forEach((container) => {
      const parent = container.closest('.tw-carousel-list');
      if (!parent) return;

      const swiper = new window.Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        navigation: {
          nextEl: parent.querySelector('.swiper-buttons .swiper-button-next'),
          prevEl: parent.querySelector('.swiper-buttons .swiper-button-prev'),
        },
        pagination: !isXl
          ? {
              el: container.querySelector('.swiper-pagination'),
              clickable: true,
              type: 'progressbar',
            }
          : false,
      });

      swipers.push(swiper);
    });
  };

  // Set up media query
  const mediaQuery = window.matchMedia('(min-width: 1280px)');

  const handleMediaChange = (e) => {
    initSwipers(e.matches);
  };

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', handleMediaChange);
  } else if (mediaQuery.addListener) {
    // For older browsers
    mediaQuery.addListener(handleMediaChange);
  }

  initSwipers(mediaQuery.matches);
}

document.addEventListener('DOMContentLoaded', initCardListSwiperWrapper);
document.addEventListener('shopify:section:load', initCardListSwiperWrapper);
